import { useState } from 'react';
import styles from './ImageCard.module.css';

function ImageCard({ src, filename, editable, onClose, onToggle, onUndo, onCloseup, onRetry, isPendingRemove, isPendingDisable, isPendingEnable, isDisabled, index }) {
  const [loaded, setLoaded]               = useState(false);
  const [confirmRemove, setConfirmRemove] = useState(false);

  const hasPending = isPendingRemove || isPendingDisable || isPendingEnable;
  const cardClass = [
    styles.card,
    editable && isPendingRemove  ? styles.borderRemove  : '',
    editable && isPendingDisable ? styles.borderDisable : '',
    editable && isPendingEnable  ? styles.borderEnable  : '',
  ].join(' ');
  // Image fades only on the SAVED disabled state, not on a pending toggle.
  const imgClass  = `${styles.image} ${isDisabled ? styles.imageDisabled : ''} ${(editable && isPendingRemove) ? styles.imagePendingRemove : ''}`;
  // Toggle icon reflects the pending intent if any, else the saved state.
  const effectiveDisabled = isPendingDisable ? true : isPendingEnable ? false : isDisabled;

  return (
    <>
      <div className={styles.wrapper}>
        <div className={cardClass}>
          {!loaded && <div className={styles.skeleton} />}
          <a
            data-pswp-src={src}
            data-pswp-width="1600"
            data-pswp-height="1067"
            style={{ display: loaded ? 'block' : 'none' }}
          >
            <img
              src={src}
              alt={filename}
              className={imgClass}
              onLoad={() => setLoaded(true)}
              title="Click to view full size"
            />
          </a>
          {index !== undefined && loaded && (
            <div className={styles.badge}>{index}</div>
          )}
          {editable && (
            <div className={styles.actions}>
              <button className={styles.actionBtn} onClick={onUndo} disabled={!hasPending} title="Undo change" aria-label="Undo change">
                <i className={`bi bi-arrow-counterclockwise ${styles.iconUndo}`} />
              </button>
              <button
                className={styles.actionBtn}
                onClick={(e) => { e.preventDefault(); e.stopPropagation(); onRetry(); }}
                disabled={isPendingRemove}
                title="Retry with another material"
                aria-label="Retry"
              >
                <i className={`bi bi-stars ${styles.iconRetry}`} />
              </button>
              <button
                className={styles.actionBtn}
                onClick={(e) => { e.preventDefault(); e.stopPropagation(); onCloseup(); }}
                disabled={isPendingRemove}
                title="Create closeup"
                aria-label="Create closeup"
              >
                <i className={`bi bi-zoom-in ${styles.iconCloseup}`} />
              </button>
              <button
                className={styles.actionBtn}
                onClick={onToggle}
                disabled={isPendingRemove}
                title={effectiveDisabled ? 'Enable image' : 'Disable image'}
              >
                <i className={`bi ${effectiveDisabled ? 'bi-eye' : 'bi-eye-slash'} ${effectiveDisabled ? styles.iconEnable : styles.iconDisable}`} />
              </button>
              <button
                className={styles.actionBtn}
                onClick={(e) => { e.preventDefault(); e.stopPropagation(); setConfirmRemove(true); }}
                disabled={isPendingDisable || isPendingEnable}
                title="Remove"
              ><i className={`bi bi-trash ${styles.iconRemove}`} /></button>
            </div>
          )}
        </div>
        {filename && <p className={styles.filename}>{filename}</p>}
      </div>

      {confirmRemove && (
        <div className={styles.confirmOverlay}>
          <div className={styles.confirmBox}>
            <p className={styles.confirmMsg}>Remove this image?</p>
            <div className={styles.confirmBtns}>
              <button className={styles.confirmCancel} onClick={() => setConfirmRemove(false)}>Cancel</button>
              <button className={styles.confirmOk} onClick={() => { setConfirmRemove(false); onClose(); }}>Remove</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ImageCard;
